export { default } from './AdminMarkingCodes';
